var exports = {
  "WB": "DMWelcomeSection.module__welcomeSection___bDhRYn",
  "rZ": "DMWelcomeSection.module__profileSection___bDhRYn",
  "KI": "DMWelcomeSection.module__avatarButton___bDhRYn",
  "xO": "DMWelcomeSection.module__usernameButton___bDhRYn",
  "Xh": "DMWelcomeSection.module__username___bDhRYn",
  "Yh": "DMWelcomeSection.module__welcomeText___bDhRYn",
  "A2": "DMWelcomeSection.module__actionSection___bDhRYn",
  "I9": "DMWelcomeSection.module__mutualGuildsContainer___bDhRYn",
  "Ko": "DMWelcomeSection.module__guildIconWrapper___bDhRYn",
  "$f": "DMWelcomeSection.module__guildIcon___bDhRYn",
  "Ii": "DMWelcomeSection.module__mutualGuildsText___bDhRYn",
  "fc": "DMWelcomeSection.module__actionButtonsContainer___bDhRYn",
};

module.exports = exports;
